import { cva } from 'class-variance-authority'
import { cn } from '~/lib/utils'

import MarkDown from '~/components/Helpers/MarkDown'
import Icon from '~/components/Helpers/Icon'
import TertiaryLink from '~/components/UI/Buttons/TertiaryLink/TertiaryLink'
import CardOverlay from '../CardOverlay/CardOverlay'

const cardVariants = cva(
  'relative p-xs-plus max-h-[500px] !h-[500px] flex flex-col gap-s sm:p-s',
  {
    variants: {
      backgroundColour: {
        'ink-blue': 'bg-blue-d text-white',
        'mid-blue': 'bg-blue-m text-white',
        'light-grey': 'bg-grey-l text-blue-d',
        white: 'bg-white text-blue-d'
      }
    },
    defaultVariants: {
      backgroundColour: 'ink-blue'
    }
  }
)

const StatisticCard = ({ content, carousel, className }: CardProps) => {
  const { backgroundColour, icon, heading, copy, expandedCopy, buttons } =
    content

  const button = buttons ? buttons[0] : null

  const foregroundColour =
    backgroundColour === 'ink-blue' || backgroundColour === 'mid-blue'
      ? 'white'
      : icon?.duotone
        ? 'mid-blue'
        : 'ink-blue'

  const useDuotone = icon?.duotone || button?.strongColour ? true : false

  const expandedColour =
    backgroundColour === 'ink-blue'
      ? (icon?.duotone && icon?.accentColour) || foregroundColour
      : foregroundColour

  return (
    <div className={cn(cardVariants({ backgroundColour }), className)}>
      <div className='grow self-end'>
        <Icon
          icon={{ ...icon, duotone: useDuotone }}
          backgroundColour={backgroundColour}
          className={
            carousel ? '[&>img]:h-l [&>img]:w-l' : '[&>img]:h-xl [&>img]:w-xl'
          }
        />
      </div>
      <div className='gap-2xs lg:px-2xs lg:pb-2xs flex flex-col'>
        <h2 className='text-h1-sm text-h1 font-serif text-balance sm:text-[46px] lg:text-[48px]'>
          {heading}
        </h2>
        <MarkDown className='flex items-center' content={copy} />
        {button && !expandedCopy && (
          <div className='mt-s w-fit'>
            <TertiaryLink
              data={{ ...button, strongColour: useDuotone }}
              colour={foregroundColour}
            />
          </div>
        )}
      </div>
      {expandedCopy && (
        <CardOverlay overlayText={expandedCopy} colour={expandedColour} />
      )}
    </div>
  )
}

export default StatisticCard
